import InitialFileTypeLabel from '@/common/components/fileTypeLabel/InitialFileTypeLabel.tsx';
import BodyFileTypeLabel from '@/common/components/fileTypeLabel/BodyFileTypeLabel.tsx';
import PropertyFileTypeLabel from '@/common/components/fileTypeLabel/PropertyFileTypeLabel.tsx';
import { FileTypeConst } from '@/common/types/Files.type.ts';

export default ({ fileType }: { fileType: FileTypeConst }) => {
  if (fileType === 'initial') {
    return <InitialFileTypeLabel />;
  }
  if (fileType === 'body') {
    return <BodyFileTypeLabel />;
  }
  return <PropertyFileTypeLabel />;
};
